export default function SelectOverrides() {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#868B8F',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#868B8F',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFF',
          },
          '&.Mui-disabled .MuiSelect-icon': {
            color: '#868B8F',
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: '#868B8F',
          },
          '& .MuiSelect-icon': {
            color: '#FFF',
          },
          '& .MuiSelect-select': {
            color: '#FFF',
          },
          '& .MuiSelect-select.Mui-disabled': {
            WebkitTextFillColor: '#868B8F !important',
            opacity: 1,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#868B8F',
          '&.Mui-focused': {
            color: '#FFF',
          },
          '&.Mui-disabled': {
            color: '#868B8F',
            opacity: 0.6,
          },
        },
      },
    },

  };
}
